'use client'

import type { FC } from 'react'
import { useAppConfigContext } from '#/src/appConfig'
import { FooterStandard, type FooterStandardProps } from 'storefront-modules/layout/footer'
import { FooterLogo } from '#/src/custom/layout/FooterLogo'

type IFooter = Pick<FooterStandardProps, 'footerItems' | 'socialMediaItems'>

const CustomFooter: FC<IFooter> = ({ footerItems, socialMediaItems }) => {
  const appConfig = useAppConfigContext()

  return (
    <FooterStandard
      logo={<FooterLogo />}
      footerItems={footerItems}
      socialMediaItems={socialMediaItems}
      paymentProviderName={appConfig.paymentProviderConfig?.providerName}
      paymentMethodLogos={appConfig.paymentMethodLogos}
      showPaymentLogo={appConfig.footerConfig?.showPaymentLogo !== false}
      maxColumns={appConfig.footerConfig?.maxColumns}
    />
  )
}

export default CustomFooter
